<template>
	<PopupRouterViewDetail label="Download Process Detail" @copyDataMethod="copyDataAction" :isShowCopyData="false">
<!-- APP_DETAIL_HEADER -->
		<b-card>
			<b-col cols="12" lg="6">
					<b-form-group id="fieldset-job-id" label-cols-sm="4" label-cols-lg="3" label="Job ID" label-for="filter-job-id">
						{{ model != null ? model.jobId : "" }}
					</b-form-group>
					<b-form-group id="fieldset-function-id" label-cols-sm="4" label-cols-lg="3" label="Function" label-for="filter-function-id">
						{{ model != null ? model.functionId : "" }}
					</b-form-group>
					<b-form-group id="fieldset-file-name" label-cols-sm="4" label-cols-lg="3" label="File Name" label-for="filter-file-name">
						{{ model != null ? model.fileName : "" }}
					</b-form-group>
					<b-form-group id="fieldset-start-time" label-cols-sm="4" label-cols-lg="3" label="Start Time" label-for="filter-start-time">
						{{ (model != null ? model.startTime : "") | moment("DD-MMM-YYYY HH:mm") }}
					</b-form-group>
					<b-form-group id="fieldset-end-time" label-cols-sm="4" label-cols-lg="3" label="End Time" label-for="filter-end-time">
						{{ (model != null ? model.endTime : "") | moment("DD-MMM-YYYY HH:mm") }}
					</b-form-group>
					<b-form-group id="fieldset-status" label-cols-sm="4" label-cols-lg="3" label="Status" label-for="filter-status">
						{{ model != null ? model.status : "" }}
					</b-form-group>
					<b-form-group id="fieldset-error-message" label-cols-sm="4" label-cols-lg="3" label="Error Message" label-for="filter-error-message">
						{{ model != null ? model.errorMessage : "" }}
					</b-form-group>
			</b-col>
		</b-card>
<!-- END_APP_DETAIL_HEADER -->
		<b-overlay :show="isBusy" no-wrap></b-overlay>
		<template #modal-left-button>
			<b-overlay
					v-if="model.status == 'SUCCESS'"
					:show="isDownloadProcess"
					rounded
					opacity="0.6"
					spinner-small
					spinner-variant="warning"
					class="d-inline-block"
					>
					<b-button variant="success" class="float-left ml-2" @click="downloadFile" size="sm"><b-icon-download class="mr-1"></b-icon-download> Download File</b-button>
				<!-- pasang ini -> v-b-modal.modal-1 -->
			</b-overlay>
		</template>
	</PopupRouterViewDetail>
</template>
<script>
/*APP_DETAIL_IMPORT*/
import DownloadProcess from '@/models/DownloadProcess/DownloadProcess';
import DownloadProcessList from '@/models/DownloadProcess/DownloadProcessList';
import DownloadProcessFilter from '@/filters/DownloadProcess/DownloadProcessFilter';

import PopupRouterViewDetail from '@/components/PopupRouterViewDetail';
import AppInputDatetimepicker from '@/components/AppInputDatetimepicker';
import AppInputDatetimepickerRange from '@/components/AppInputDatetimepickerRange';
/*END_APP_DETAIL_IMPORT*/
export default {
	components : {
	/*APP_DETAIL_PROP_DEFINITION*/
	PopupRouterViewDetail,AppInputDatetimepicker,AppInputDatetimepickerRange,
	/*APP_DETAIL_COMPONENTS_DEFINITION*/
},
	data() {
		return {
			fileupload: null,
			datas: Array(),
			busy:false,
			isBusy: false,
			isDataLoading: false,
			selected:'',
			model: {},
			/*APP_DETAIL_PAGINATION*/
			/*END_APP_DETAIL_PAGINATION*/
			/*APP_DETAIL_FILTER*/
			filterDownloadProcess : null,
			/*END_APP_DETAIL_FILTER*/
			/*APP_DETAIL_PAGING_DEFINITION*/
			currentDownloadProcessPage : 1,
			downloadProcessPageSize: 10,
			/*END_APP_DETAIL_PAGING_DEFINITION*/
			/*APP_DETAIL_SORT_DEFINITION*/
			sortByDownloadProcess: '',
			sortDescDownloadProcess: '',
			/*END_APP_DETAIL_SORT_DEFINITION*/
			/*APP_DETAIL_VARIABLE_DEFINITION*/
			/*END_APP_DETAIL_VARIABLE_DEFINITION*/
			/*APP_DETAIL_OBJ_VARIABLE*/
			/*END_APP_DETAIL_OBJ_VARIABLE*/
			isDownloadProcess: false,
		}
	},
	methods : {
		/*APP_DETAIL_GETDownloadProcess*/
		getDownloadProcess : async function(id) {
			this.isBusy = true;
			DownloadProcess.getData(this, id).then(result => { this.model = result; this.isBusy = false; }).catch(error => { this.isBusy = false; });
		},
		/*END_APP_DETAIL_GETDownloadProcess*/
		/*APP_DETAIL_COPYDATA*/
		copyDataAction(modelEvent) {
			this.$router.push({ name: 'downloadprocesscopydata', params: { id: this.modelId, copydata : 1 } })
		},
		/*END_APP_DETAIL_COPYDATA*/
		/*APP_DETAIL_DISPLAYFILTER*/
		displayFilter() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 768 ) {
			}
		},
		/*END_APP_DETAIL_DISPLAYFILTER*/
		async downloadFile() {
          	let this_ = this;
			this.isDownloadProcess = true;
		  	this.$http.get("downloadprocess/download/" + this.modelId).then(result => {
				console.log(result);
			  	let dataUrl = result.data.download;
				this.$http.get(dataUrl, {responseType: 'blob'}).then(async response => {
					if (response != null) {
						await saveAs(response.data, this_.model.fileName);
						this.isDownloadProcess = false;
					}
					this.isDownloadProcess = false;
				}).catch(error => {
					this.$store.dispatch('addErrorMessageGlobal', error);
					this.isDownloadProcess = false;
					throw error;
				});
		  	}).catch(error => {
				this.$store.dispatch('addErrorMessageGlobal', error);
				this.isDownloadProcess = false;
				throw error;
			});
        },
	},
	/*APP_DETAIL_BEFORE_MOUNT*/
	beforeMount() {
		this.filterDownloadProcess = new DownloadProcessFilter();
	},
	/*END_APP_DETAIL_BEFORE_MOUNT*/
	/*APP_DETAIL_MOUNTED*/
	mounted(){
		let id = this.$route.params.id;
		this.modelId = id;
		this.getDownloadProcess(id);
		this.$nextTick(() => {
			window.addEventListener('resize', this.displayFilter);
			this.displayFilter();
		});
	},
	/*END_APP_DETAIL_MOUNTED*/
	watch : {
	},
	/*APP_DETAIL_COMPUTED*/
	computed: {
	}
	/*END_APP_DETAIL_COMPUTED*/
}
</script>
